import React from 'react'
import {
  List,
  ListItem,
  ListItemText,
  Typography,
  Chip,
  Box
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { format, parseISO } from 'date-fns'
import { ptBR } from 'date-fns/locale'

const useStyles = makeStyles(theme => ({
  taskContainer: {
    maxHeight: '400px',
    overflowY: 'auto'
  },
  taskItem: {
    cursor: 'pointer',
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_700.main
        : theme.palette.gray_100.main,
    borderRadius: 8,
    padding: '2px 16px',
    '&:hover': {
      backgroundColor: theme.palette.action.hover
    }
  },
  taskTitle: {
    fontWeight: 'bold',
    fontSize: '0.95rem',
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.primary
  },
  commentNotification: {
    backgroundColor: '#e3f2fd',
    borderLeft: '4px solid #2196f3'
  },
  taskDescription: {
    fontSize: '0.85rem',
    color: theme.palette.text.secondary,
    marginTop: theme.spacing(0.5)
  },
  chipContainer: {
    display: 'flex',
    gap: theme.spacing(0.5),
    marginTop: theme.spacing(0.5),
    flexWrap: 'wrap'
  },
  priorityChip: {
    fontSize: '0.7rem',
    height: '20px'
  },
  statusChip: {
    fontSize: '0.7rem',
    height: '20px'
  },
  dueDate: {
    fontSize: '0.75rem',
    color: theme.palette.text.secondary,
    marginTop: theme.spacing(0.5)
  }
}))

const TasksPopOver = ({ tasks, onClose, onTaskRead, onTaskClick }) => {
  const classes = useStyles()

  const getPriorityColor = priority => {
    switch (priority) {
      case 'alta':
        return 'secondary'
      case 'media':
        return 'primary'
      case 'baixa':
        return 'default'
      default:
        return 'default'
    }
  }

  const getStatusColor = status => {
    switch (status) {
      case 'concluida':
        return '#4caf50'
      case 'em_andamento':
        return '#2196f3'
      case 'pendente':
        return '#ff9800'
      case 'vencida':
        return '#f44336'
      default:
        return '#9e9e9e'
    }
  }

  const getStatusLabel = status => {
    switch (status) {
      case 'concluida':
        return 'Concluída'
      case 'em_andamento':
        return 'Em Andamento'
      case 'pendente':
        return 'Pendente'
      case 'vencida':
        return 'Vencida'
      default:
        return status
    }
  }

  const handleTaskClick = task => {
    if (onTaskRead) onTaskRead(task.id)
    if (onClose) onClose()
    if (onTaskClick) onTaskClick(task)
  }

  return (
    <List component="nav" className={classes.taskContainer}>
      {tasks.map(task => (
        <ListItem
          key={`${task.id}-${task._isComment ? 'comment' : 'task'}`}
          className={`${classes.taskItem} ${task._isComment ? classes.commentNotification : ''}`}
          onClick={() => handleTaskClick(task)}
        >
          <ListItemText
            primary={
              <Typography className={classes.taskTitle}>
                {task._isComment ? `💬 ${task.title}` : task.title}
              </Typography>
            }
            secondary={
              <>
                {task._isComment && task._commentMessage && (
                  <Typography className={classes.taskDescription}>
                    {task._commentMessage}
                  </Typography>
                )}
                {!task._isComment && task.description && (
                  <Typography className={classes.taskDescription}>
                    {task.description.length > 100
                      ? `${task.description.substring(0, 100)}...`
                      : task.description}
                  </Typography>
                )}
                {/* <Box className={classes.chipContainer}>
                  <Chip
                    label={task.priority}
                    color={getPriorityColor(task.priority)}
                    size="small"
                    className={classes.priorityChip}
                  />
                  <Chip
                    label={getStatusLabel(task.status)}
                    size="small"
                    className={classes.statusChip}
                    style={{
                      backgroundColor: getStatusColor(task.status),
                      color: 'white'
                    }}
                  />
                </Box> */}
                {task.dueDate && (
                  <Typography className={classes.dueDate}>
                    Vencimento:{' '}
                    {format(parseISO(task.dueDate), "dd/MM/yyyy 'às' HH:mm", {
                      locale: ptBR
                    })}
                  </Typography>
                )}
              </>
            }
          />
        </ListItem>
      ))}
    </List>
  )
}

export default TasksPopOver
